module.exports = __webpack_public_path__ + "img/shequhuodong.f664139b.png";